export const text =
`
I made a game called CodeSpells
`
